export enum EnumEstadoTarea {
  Nueva = 1,
  EnCurso,
  Finalizada
}
